import { useTracking } from '../../hooks/useTracking';

/**
 * TrackingProvider component that initializes page tracking
 * Must be used inside a Router component
 */
const TrackingProvider = ({ children }) => {
  // Initialize tracking - this will automatically track page views
  useTracking();
  
  // This component doesn't render anything, just provides tracking functionality
  return children || null;
};

export default TrackingProvider;